import React, { useState, useEffect } from "react";
import { Menu, Icon, Input, Row, Col } from "antd";
import { NavLink } from "react-router-dom";
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import Scrollbars from "react-custom-scrollbars";
import message from '../../components/Messages'
import typo, { MESSAGE } from "../../constants/dictionaries";
import Api from '../../api'
import "./antd-menu.scss";
import helper from '../../helper/helper';
import { groupFunctionsCode, functionsCode } from "../../constants/constant";
//image
import TrangChu from '../../assets/images/TrangChu.png'
import DMQuanTrac from '../../assets/images/DMQuanTrac.png'
import GP_img from '../../assets/images/GP.png'
import DLQuanTracDK from '../../assets/images/DLQuanTracDK.png'
import DM_img from '../../assets/images/DM.png'
import CauHinh from '../../assets/images/CauHinh.png'
import BanDo from '../../assets/images/BanDo.png'
import NKHT from '../../assets/images/NKHT.png'
import HDSD from '../../assets/images/HDSD.png'
const SubMenu = Menu.SubMenu;

const Navigation = ({ collapsed, user, addFunctions, isCollapsed }) => {
  const [openKeys, setOpenKeys] = useState(localStorage.getItem("GEN_menu_isCollapsed") === "true"
    ? []
    : localStorage.getItem("GEN_defaultOpenKeys")
      ? JSON.parse(localStorage.getItem("GEN_defaultOpenKeys"))
      : ["sub1"]);

  const [listFunctions, setListFunctions] = useState([]);
  const rest = collapsed ? {} : { openKeys };

  const updateKey = key => {
    const keysToUpdate = openKeys.includes(key) ? [] : [key];
    localStorage.setItem("GEN_defaultOpenKeys", JSON.stringify(keysToUpdate));
    setOpenKeys(keysToUpdate)
  };

  useEffect(() => {
    if (collapsed) {
      window.cacheOpenKeys = openKeys;
      setOpenKeys([]);
    } else {
      if (window.cacheOpenKeys) {
        setOpenKeys(window.cacheOpenKeys)
      }
    }
  }, [collapsed]);

  useEffect(() => {
    getFunctionsByRole()
  }, user);

  const getFunctionsByRole = () => {
    if (user) {
      new Api().getFunctionsByRole({ token: user.access_token })
        .then(data => {
          setListFunctions(data);
          addFunctions(data)
        }).catch(err => {
          message.error(MESSAGE.CSCORE_ERROR)
        })
    }
  };

  const groupFunctions = helper.handleGroupFunctions(listFunctions, groupFunctionsCode);

  return (
    <div style={{ height: "calc(100vh - 124px)" }}>
      <Scrollbars
        autoHide renderThumbVertical={() => (<div style={{ backgroundColor: "#fff", borderRadius: 5, opacity: 0.4 }} />)}>
        <Menu className='menu-box' defaultSelectedKeys={[]} // defaultOpenKeys={defaultOpenKeys}
          {...rest} key={collapsed} mode="inline"
          style={{ backgroundColor: "transparent", color: "#fff", border: "none", marginTop: "50px !important" }}>

          {!isEmpty(groupFunctions[groupFunctionsCode.TRANG_CHU]) &&
            <Menu.Item className='menu-item-box' key="item1">
              <NavLink activeClassName='active-menu-item-content' to="/dashboard">
                <span className='menu-item-content'>

                  <img className='menu-item-img1' src={TrangChu} />
                  <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>Trang chủ</span>
                </span>
              </NavLink>
            </Menu.Item>}

          {!isEmpty(groupFunctions[groupFunctionsCode.TKDN]) &&
            <Menu.Item className='menu-item-box' key="item9">
              <NavLink activeClassName='active-menu-item-content' to="/Tra-cuu-doanh-nghiep">
                <span className='menu-item-content'>

                  <img className='menu-item-img1' src={DMQuanTrac} />
                  <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>Tra cứu doanh nghiệp</span>
                </span>
              </NavLink>
            </Menu.Item>}

          {!isEmpty(groupFunctions[groupFunctionsCode.BCDN]) &&
            <SubMenu className='menu-item-subbox' key="sub15" onTitleClick={() => {
              updateKey("sub15")
            }}
              title={<span className='menu-item-content'>

                <img className='menu-item-img1' src={GP_img} />
                <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>Dành cho doanh nghiệp</span>
              </span>}>
              <hr className="hr_custom"></hr>
              <p style={{ padding: '10px 0px 0px 5px', color: '#ffffff47' }}>Báo cáo định kỳ</p>
              {groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_TNN) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/BCDN/TNN"> {typo.cscore_tai_nguyen_nuoc} </NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_DTM) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/BCDN/DTM"> {typo.cscore_dtm} </NavLink>
                </Menu.Item>}
              {groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_BVMT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/BCDN/BVMT"> {typo.cscore_bao_ve_moi_truong} </NavLink>
                </Menu.Item>}
              {groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_BC) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/BCDN/thongke"> {typo.cscore_statistic} </NavLink>
                </Menu.Item>}

              <hr className="hr_custom"></hr>
              <p style={{ padding: '10px 0px 0px 5px', color: '#ffffff47' }}>Đề nghị cập nhật cấp phép</p>
              {groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_CNCP) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/BCDN/CNCP"> {typo.cscore_cap_nhat_cap_phep} </NavLink>
                </Menu.Item>}

              {/* Hướng dẫn sử dụng */}
              {groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_HDSD) &&
                <div>
                  <hr className="hr_custom"></hr>
                  <p style={{ padding: '10px 0px 0px 5px', color: '#ffffff47' }}>Hướng dẫn sử dụng</p>
                  <Menu.Item className='menu-item-box' key="item4"
                  >
                    <a onClick={() => window.open("https://www.youtube.com/watch?v=ERDl2W0Svbw&t=6s")} activeClassName='active-menu-item-content'>
                      <span className='menu-item-content'>
                        <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>Clip hướng dẫn nhập báo cáo</span>
                      </span>
                    </a>
                  </Menu.Item></div>}
            </SubMenu>}

          {!isEmpty(groupFunctions[groupFunctionsCode.TNN]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => {
              updateKey("sub1")
            }} key="sub1" title={
              <span className='menu-item-content'>

                <img className='menu-item-img1' src={GP_img} />
                <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_tai_nguyen_nuoc}</span>
              </span>}>

              {groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_XT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/tai-nguyen-nuoc/xa-thai">{typo.cscore_drawer_cp_xt}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_NM) &&
                <Menu.Item
                  className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/tai-nguyen-nuoc/khai-thac-nuoc-mat">{typo.cscore_drawer_cp_ktnm}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_NB) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/tai-nguyen-nuoc/khai-thac-nuoc-bien">{typo.cscore_drawer_cp_ktnb}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_KTNDD) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/tai-nguyen-nuoc/khai-thac-nuoc-duoi-dat">{typo.cscore_drawer_cp_ktndd}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_TDNDD) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/tai-nguyen-nuoc/tham-do-nuoc-duoi-dat">{typo.cscore_drawer_cp_tdndd}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_HN) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/tai-nguyen-nuoc/hanh-nghe-khoan-nuoc">{typo.cscore_drawer_cp_hnkndd}</NavLink>
                </Menu.Item>}
            </SubMenu>}

          {!isEmpty(groupFunctions[groupFunctionsCode.MT]) &&
            <SubMenu className='menu-item-subbox' key="sub16" onTitleClick={() => {
              updateKey("sub16")
            }}
              title={<span className='menu-item-content'>

                <img className='menu-item-img1' src={GP_img} />
                <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_moi_truong}</span>
              </span>}>
              {groupFunctions[groupFunctionsCode.DTM].includes(functionsCode.DTM_BCPD) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/DTM/bao-cao-phe-duyet">Báo cáo ĐTM đã phê duyệt </NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.BVMT].includes(functionsCode.BVMT_DACT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/bao-ve-moi-truong/de-an-chi-tiet"> Thủ tục môi trường khác </NavLink>
                </Menu.Item>}

            </SubMenu>}

          {!isEmpty(groupFunctions[groupFunctionsCode.HTMT]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => updateKey("sub4")} key="sub4"
              title={
                <span className='menu-item-content'>

                  <img className='menu-item-img1' src={GP_img} />
                  <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_hien_trang_moi_truong}</span>


                </span>}>

              {groupFunctions[groupFunctionsCode.HTMT].includes(functionsCode.HTMT_BCDK) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/hien-trang-moi-truong/Bao-cao-dinh-ky">{typo.cscore_doanhngiepbaocao}</NavLink>
                </Menu.Item>}
              {groupFunctions[groupFunctionsCode.HTMT].includes(functionsCode.HTMT_TQT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/hien-trang-moi-truong/tram-quan-trac">{typo.cscore_drawer_qt_tqtn}</NavLink>
                </Menu.Item>}
            </SubMenu>}

          {!isEmpty(groupFunctions[groupFunctionsCode.NTTS]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => {
              updateKey("sub5")
            }} key="sub5"
              title={
                <span className='menu-item-content'>
                  <img className='menu-item-img1' src={GP_img} />
                  <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_nuoi_trong_thuy_san}</span>
                </span>}>

              {groupFunctions[groupFunctionsCode.NTTS].includes(functionsCode.NTTS_BCDK) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/nuoi-trong-thuy-san/bao-cao-dinh-ky">{typo.cscore_bao_cao_dinh_ky}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.NTTS].includes(functionsCode.NTTS_TQT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/nuoi-trong-thuy-san/tram-quan-trac">{typo.cscore_drawer_qt_tqtn}</NavLink>
                </Menu.Item>}
            </SubMenu>}

          {!isEmpty(groupFunctions[groupFunctionsCode.QTVHL]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => {
              updateKey("sub12")
            }} key="sub12"
              title={
                <span className='menu-item-content'>

                  <img className='menu-item-img1' src={DLQuanTracDK} />
                  <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_draw_qtvinhhalong}</span>
                </span>}>

              {groupFunctions[groupFunctionsCode.QTVHL].includes(functionsCode.QTVHL) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/QT-vinh-ha-long/bao-cao-dinh-ky">{typo.cscore_bao_cao_dinh_ky}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.QTVHL].includes(functionsCode.QTVHL_TQT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/QT-vinh-ha-long/tram-quan-trac">{typo.cscore_drawer_qt_tqtn}</NavLink>
                </Menu.Item>}
            </SubMenu>}

          {!isEmpty(groupFunctions[groupFunctionsCode.TTKT]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => {
              updateKey("sub6")
            }} key="sub6"
              title={
                <span className='menu-item-content'>

                  <img className='menu-item-img1' src={DM_img} />
                  <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_ttkt}</span>
                </span>}>

              {groupFunctions[groupFunctionsCode.TTKT].includes(functionsCode.QDXPVP_KHTKT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Thanh-tra-kiem-tra/ke-hoach-thanh-kiem-tra">Kế hoạch thanh kiểm tra</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.TTKT].includes(functionsCode.QDXPVP) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Thanh-tra-kiem-tra/quyet-dinh-xu-phat-vi-pham"> {typo.cscore_quyet_dinh_xu_phat_vi_pham} </NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.TTKT].includes(functionsCode.QDXPVP_TQT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Thanh-tra-kiem-tra/tram-quan-trac"> QĐXP - Vị trí quan trắc </NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.TTKT].includes(functionsCode.QDXPVP_TQT_TKT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Thanh-tra-kiem-tra/tram-quan-trac-thanh-kiem-tra"> TKT - Vị trí quan trắc </NavLink>
                </Menu.Item>}

            </SubMenu>}

          {!isEmpty(groupFunctions[groupFunctionsCode.CAT]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => {
              updateKey("sub14")
            }} key="sub14"
              title={
                <span className='menu-item-content'>

                  <img className='menu-item-img1' src={DM_img} />
                  <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_congantinh}</span>
                </span>}>

              {groupFunctions[groupFunctionsCode.CAT].includes(functionsCode.CAT_KHTKT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Cong-an-tinh/ke-hoach-thanh-kiem-tra">Kế hoạch thanh kiểm tra</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.CAT].includes(functionsCode.CAT_QDXPVP) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Cong-an-tinh/quyet-dinh-xu-phat-vi-pham"> {typo.cscore_quyet_dinh_xu_phat_vi_pham} </NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.CAT].includes(functionsCode.CAT_TQT_KHTKT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Cong-an-tinh/tram-quan-trac-thanh-kiem-tra">TKT - Vị trí quan trắc </NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.CAT].includes(functionsCode.CAT_TQT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Cong-an-tinh/tram-quan-trac"> QĐXP - Vị trí quan trắc </NavLink>
                </Menu.Item>}

            </SubMenu>}


          {!isEmpty(groupFunctions[groupFunctionsCode.CHTS]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => updateKey("sub7")} key="sub7"
              title={<span className='menu-item-content'>

                <img className='menu-item-img1' src={CauHinh} />
                <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_drawer_qt_chts}</span>
              </span>}>

              {groupFunctions[groupFunctionsCode.CHTS].includes(functionsCode.CHTS_TS) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Cau-hinh-thong-so/Cau-hinh-thong-so-doi-tuong">{typo.cscore_drawer_qt_chtdt}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.CHTS].includes(functionsCode.CHTS_QC) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Cau-hinh-thong-so/Cau-hinh-thong-so-theo-quy-chuan">{typo.cscore_drawer_qt_chtstc}</NavLink>
                </Menu.Item>}
            </SubMenu>}

          {!isEmpty(groupFunctions[groupFunctionsCode.DMQT]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => updateKey("sub8")} key="sub8"
              title={<span className='menu-item-content'>

                <img className='menu-item-img1' src={DMQuanTrac} />
                <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_drawer_dm_qt}</span>

              </span>}>

              {groupFunctions[groupFunctionsCode.DMQT].includes(functionsCode.DMQT_DVD) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc-quan-trac/Don-vi-do">{typo.cscore_don_vi_do}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DMQT].includes(functionsCode.DMQT_PPLM) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc-quan-trac/Phuong-phap-lay-mau">{typo.cscore_phuong_phap_LM}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DMQT].includes(functionsCode.DMQT_PPPT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc-quan-trac/Phuong-phap-phan-tich">{typo.cscore_phuong_phap_PT}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DMQT].includes(functionsCode.DMQT_MDSD) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc-quan-trac/Muc-dich-su-dung">{typo.cscore_mucdichsudung}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DMQT].includes(functionsCode.DMQT_TQT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc-quan-trac/Tuyen-quan-trac">{typo.cscore_tuyen_QT}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DMQT].includes(functionsCode.DMQT_TSQT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc-quan-trac/Thong-so-quan-trac">{typo.cscore_drawer_qt_tt}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DMQT].includes(functionsCode.DMQT_TCAP) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc-quan-trac/Tieu-chuan-ap-dung">{typo.cscore_drawer_qt_tcad}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DMQT].includes(functionsCode.DMQT_TCDG) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc-quan-trac/Tieu-chuan-danh-gia">{typo.cscore_drawer_qt_tcdg}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DMQT].includes(functionsCode.DMQT_DA) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc-quan-trac/Du-an">{typo.cscore_tt_duan}</NavLink>
                </Menu.Item>}
              {groupFunctions[groupFunctionsCode.DMQT].includes(functionsCode.DMQT_TPMT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc-quan-trac/Thanh-phan-moi-truong">{typo.cscore_thanh_phan_moi_truong}</NavLink>
                </Menu.Item>}
            </SubMenu>}

          {!isEmpty(groupFunctions[groupFunctionsCode.DM]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => updateKey("sub9")} key="sub9"
              title={<span className='menu-item-content'>
                <img className='menu-item-img1' src={DM_img} />
                <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_drawer_categories}</span>
              </span>}>

              {groupFunctions[groupFunctionsCode.DM].includes(functionsCode.DM_LVB) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc/Loai-van-ban">{typo.cscore_drawer_categories_qlvb}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DM].includes(functionsCode.DM_KTT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc/Kinh-tuyen-truc">{typo.cscore_kinh_tuyen_truc}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DM].includes(functionsCode.DM_MDSDN) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc/Muc-dich-su-dung-nuoc">{typo.cscore_muc_dich_su_dung_nuoc}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DM].includes(functionsCode.DM_LHNT) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc/Loai-hinh-nuoc-thai">{typo.cscore_loaiHinhNuocThai}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DM].includes(functionsCode.DM_KCN) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc/Khu-cong-nghiep">{typo.cscore_drawer_categories_qlkcn}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DM].includes(functionsCode.DM_TCCNDCP) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc/Don-vi-xin-cap-phep">Doanh nghiệp</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DM].includes(functionsCode.DM_LN) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc/Lang-nghe">{typo.cscore_drawer_categories_qlln}</NavLink>
                </Menu.Item>}

              {groupFunctions[groupFunctionsCode.DM].includes(functionsCode.DM_NM) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc/Nha-may">{typo.cscore_drawer_categories_qlnm}</NavLink>
                </Menu.Item>}
              {groupFunctions[groupFunctionsCode.DM].includes(functionsCode.DM_DVTD) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Danh-muc/Don-vi-tham-dinh">{typo.cscore_donvithamdinh}</NavLink>
                </Menu.Item>}
            </SubMenu>}

          {!isEmpty(groupFunctions[groupFunctionsCode.BD]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => updateKey("sub10")} key="sub10"
              title={<span className='menu-item-content'>


                <img className='menu-item-img1' src={BanDo} />
                <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_drawer_map}</span>
              </span>}>

              {groupFunctions[groupFunctionsCode.BD].includes(functionsCode.BD_TCTNN) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Ban-do/Tra-cuu-tai-nguyen-nuoc">{typo.cscore_drawer_map_tnn}</NavLink>
                </Menu.Item>
              }
            </SubMenu>}
          {!isEmpty(groupFunctions[groupFunctionsCode.NKHT]) &&
            <SubMenu className='menu-item-subbox' onTitleClick={() => updateKey("sub20")} key="sub20"
              title={<span className='menu-item-content'>


                <img className='menu-item-img1' src={NKHT} />
                <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_drawer_log}</span>
              </span>}>

              {groupFunctions[groupFunctionsCode.NKHT].includes(functionsCode.NKHT_GS) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Nhat-ky-he-thong/giam-sat">Quan trắc</NavLink>
                </Menu.Item>
              }
              {groupFunctions[groupFunctionsCode.NKHT].includes(functionsCode.NKHT_GS) &&
                <Menu.Item className='menu-item-box'>
                  <NavLink activeClassName='active-menu-item-content'
                    to="/Nhat-ky-he-thong/tai-nguyen-nuoc">Tài nguyên nước</NavLink>
                </Menu.Item>
              }
            </SubMenu>}

          <Menu.Item className='menu-item-box' key="item4" onClick={() => helper.DownloadHDSD(user)}>
            <a activeClassName='active-menu-item-content'>
              <span className='menu-item-content'>
                <img className='menu-item-img1' src={HDSD} />
                <span style={{ color: isCollapsed === true ? "#314558" : "#fff", marginLeft: "10px" }}>{typo.cscore_hdsd}</span>
              </span>
            </a>
          </Menu.Item>
        </Menu>
      </Scrollbars></div>
  )
};

Navigation.propTypes = {
  collapsed: PropTypes.any.isRequired,
};
export default Navigation 
